export default "/_next/static/images/Google_AI_Studio_2025-12-06T00_24_50.650Z 15-5460895ef444abbb3a2cac6e6d4c34bc.png";